module.exports = __webpack_public_path__ + "static/media/Positive.1f8c1963.svg";